import { ref } from 'vue';
import { type ConfigProviderProps } from '@aplus-frontend/ui';

import { getPlatform } from '@/utils/url';
import { userToken, adminToken } from './ui-token';

export default () => {
  const platform = getPlatform();
  const uiMode = platform == 'user' ? 'user' : 'admin';
  const config = ref<ConfigProviderProps>({
    // uiMode,
    theme: {
      token: uiMode === 'user' ? userToken : adminToken
    },
    namespace: 'user'
  });

  // const config = computed(() => _config.value);
  const setConfig = (configNew: ConfigProviderProps) => {
    config.value = {
      ...config.value,
      ...configNew
    };
  };
  return {
    config,
    setConfig
  };
};
